import { AotSummaryResolver } from '@angular/compiler';
import { Component, OnInit, HostListener, NgModule, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import AOS from 'aos';
import { filter } from 'rxjs/operators'
import { Subscription } from 'rxjs';
import Swiper from 'swiper';
import SwiperCore, {
  Navigation,
  Pagination,
  Autoplay
} from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay]);

@Component({ 
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit, OnDestroy{

subscription: Subscription;

constructor(private router: Router){}

@ViewChild('contentCylinder') ContentCylinder: ElementRef;

ngOnInit(){
  AOS.init();
  this.subscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd ))
    .subscribe(() => window.scrollTo(0, 0));
}

ngOnDestroy(){
  this.subscription.unsubscribe();
}

check:boolean=false;
onClick(){
  this.check = !this.check;
}

scroll_down:boolean=false;
nav_down:boolean=false;
@HostListener("document:scroll")
scrollFunction(){
  if(document.body.scrollTop>1000 || document.documentElement.scrollTop>1000){
    this.scroll_down=true;
  }
  else{
    this.scroll_down=false;
  }
  if(document.body.scrollTop>408 || document.documentElement.scrollTop>408){
    this.nav_down=true;
  }
  else{
    this.nav_down=false;
  }
}

scrollToTop(){
  window.scrollTo({top: 0,behavior: "smooth"});
}
/*
  top:any;
  cursor_top:any;
  cursor_left:any;
  left:any;
  opacity:any;
  transform_small:any;
  transform:any;
  endY:any = (window.innerHeight/2);

  @HostListener('document:mousemove',['$event'])
  onMousemove($event){ 
    this.top = ($event.clientY)+ "px";
    this.left = ($event.clientX)+ "px";
    this.endY = ($event.pageY - window.scrollY)

    
    this.cursor_top = ($event.clientY)+ "px";
    this.cursor_left = ($event.clientX)+ "px";
  }

  @HostListener('document:mouseenter',['$event'])
  onMouseenter($event){
    this.opacity = 1;
  }

  @HostListener('document:mouseleave',['$event'])
  onMouseleave($event){
    this.opacity = 0;
  }

  @HostListener('document:mousedown',['$event'])
  onMousedown($event){
    this.transform = 'translate(-50%, -50%) scale(1.25)';
    this.transform_small = 'translate(-50%, -50%) scale(0.75)'
  }

  @HostListener('document:mouseup',['$event'])
  onMouseup($event){
    this.transform = 'translate(-50%, -50%) scale(1)';
    this.transform_small = 'translate(-50%, -50%) scale(1)'
  }*/

}